import styled from "styled-components";
import {styledByDevice} from "../../../../../themes/architecture/styled-by-device";

const DefaultBox = styled.h4`
  margin: 0;
  font-size: 1.4rem;
  color: ${props => props.theme.colors.bodyText};
`;

const PcBox = styled(DefaultBox)`
  padding: 0.5rem 0;
  font-family: ${props => props.theme.font.family.bold};
`;
const MobileBox = styled(DefaultBox)`
  padding: 0;
  font-family: ${props => props.theme.font.family.medium};
`;

export const LanguageSwitcherTitleDefaultBox = styledByDevice(PcBox, MobileBox);
